import { render, staticRenderFns } from "./bdcqzs.vue?vue&type=template&id=8896d492&scoped=true"
import script from "./bdcqzs.vue?vue&type=script&lang=js"
export * from "./bdcqzs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8896d492",
  null
  
)

export default component.exports